import { NgModule } from '@angular/core';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsPasswordStrengthBarComponent } from './ms-password-strength-bar.component';

@NgModule({
	declarations: [MsPasswordStrengthBarComponent],
	imports: [SharedLibsModule],
	exports: [MsPasswordStrengthBarComponent],
	providers: [],
})
export class MsPasswordStrengthBarModule {}
